import { UserType } from 'src/types/admin/accessManagement.types';

/**
 * User Type Display Names
 *
 * Single source of truth for user type labels shown across the application.
 * Used in: TopNav badge, Access Management forms, tables, help panels, etc.
 */
export const USER_TYPE_DISPLAY_MAP: Record<UserType, string> = {
  [UserType.TECH_ADMIN]: 'Tech Admin',
  [UserType.VERITY_ADMIN]: 'Verity Admin',
  [UserType.READ_ONLY]: 'Read Only',
  [UserType.EXTENDED_ACCESS_PL]: 'Extended Access (PL)',
};

/**
 * Get display name for a user type
 * @param userType User type enum value
 * @returns Display name for the user type
 */
export const getUserTypeDisplayName = (userType: UserType): string => {
  return USER_TYPE_DISPLAY_MAP[userType];
};
